<template>
  <div class="admin-datatable">
    <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Płatności</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!showAdd" color="accent" @click="showAdd = true" dark>dodaj płatność</v-btn>
      <v-btn v-if="showAdd" flat small @click="showAdd = false">ukryj</v-btn>
    </v-toolbar>
    </v-card>
    <v-slide-y-transition>
    <v-card class="mt-2" v-if="showAdd">
          <payment-form @success="showAdd = false; refresh()"></payment-form>
    </v-card>
    </v-slide-y-transition>
    <v-card class="mt-2 pb-1">
      <v-card-title>
        <v-form class="flex">
            <v-layout row wrap justify-start>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <runner-select class="mr-2" v-model="context.runner"></runner-select>
              </v-flex>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-select
                  v-model="context.paymentStatus"
                  :items="[{value: 'paid', text: 'Opłacone'}, {value: 'unpaid', text: 'Nieopłacone'}, {value: 'exceeded', text: 'Przekroczono termin'}]"
                  label="Status płatności"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  :return-value.sync="context.start"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="context.start"
                    label="Data od"
                    prepend-icon="event"
                    readonly
                    clearable
                  ></v-text-field>
                  <v-date-picker v-model="context.start" type="month" @input="$refs.menu1.save(context.start)" no-title locale="pl"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-menu
                  ref="menu2"
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="40"
                  :return-value.sync="context.end"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="context.end"
                    label="Data do"
                    prepend-icon="event"
                    readonly
                    clearable
                  ></v-text-field>
                  <v-date-picker v-model="context.end" type="month" @input="$refs.menu2.save(context.end)" no-title locale="pl"></v-date-picker>
                </v-menu>
              </v-flex>

            </v-layout>
          </v-form>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="payments"
        :pagination.sync="context"
        :rows-per-page-items="perPageOptions"
        :total-items="rowsTotal"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <tr>
          <td>
            <router-link :to="{ name: 'runner-payments', params: { id: props.item.runner }}">
              {{props.item.runner_name}}
            </router-link>
          </td>
          <td>
            {{props.item.period | formatDate('MMMM YYYY')}}
          </td>
          <td>{{ props.item.price}}</td>
          <td>
            <payment-status :status="props.item.payment_status" :id="props.item.id" @change="refresh"></payment-status>
          </td>
          <td>
            <a v-if="props.item.document_url" :href="props.item.document_url">
              {{props.item.document_filename}}</a>
            <file-upload
              v-else
              target="uploads/"
              action="POST"
              @finish="finish($event, props.item)"
              :small=true
            >
            </file-upload>
          </td>
          <td class="actions">
            <rp-icon
              type="edit"
              tooltip="edytuj"
              class="mr-2"
              @click="props.expanded = !props.expanded"
            />
            <rp-icon
              v-if="props.item.payment_status !== 'paid'"
              type="delete"
              tooltip="usuń"
              @click="deletePayment(props.item)"
            />
          </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
            <payment-form :user-payment="props.item" @success="props.expanded = false; refresh()"></payment-form>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {fetchPayments, deletePayment, patchPayment} from './api'
import {ListMixin} from '@/utils/ListMixin'
import iziToast from 'izitoast'
import PaymentForm from './PaymentForm'
import PaymentStatus from './PaymentStatus'
import RunnerSelect from '@/runners/RunnerSelect'
import FileUpload from '@/utils/FileUpload'
import _ from 'lodash'

export const statusFormatter = function (value, key, item) {
}

export default {
  name: 'payments',
  components: {PaymentForm, RunnerSelect, PaymentStatus, FileUpload},
  mixins: [ListMixin],
  data () {
    return {
      context: {rowsPerPage: 10, sortBy: 'period', descending: true},
      menu1: false,
      menu2: false,
      showAdd: false,
      loading: true,
      payments: [],
      headers: [
        {
          value: 'runner',
          text: 'zawodnik',
          sortable: false
        },
        {
          value: 'period',
          text: 'okres',
          sortable: true
        },
        {
          value: 'price',
          text: 'cena',
          sortable: true
        },
        {
          value: 'payment_status',
          text: 'status',
          sortable: false
        },
        {
          value: 'document',
          text: 'dokument',
          sortable: false
        },
        {
          value: 'actions',
          text: 'akcje',
          align: 'center',
          sortable: false,
          width: '180px'
        }
      ]
    }
  },
  watch: {
    context: {
      handler () {
        this.getPayments()
      },
      deep: true
    }
  },
  methods: {
    finish (e, item) {
      if (e.data && e.data.id) {
        patchPayment({id: item.id, document: e.data.id}).then((data) => {
          item.document_url = data.document_url
          item.document_filename = data.document_filename
        })
      }
    },
    getPayments () {
      this.loading = true
      let params = this.prepareParams()
      if (this.context.end !== null) {
        params['period__lte'] = this.context.end
      }
      if (this.context.start !== null) {
        params['period__gte'] = this.context.start
      }
      if (this.context.runner !== null) {
        params['runner'] = this.context.runner
      }
      if (this.context.paymentStatus !== null) {
        params['payment_status'] = this.context.paymentStatus
      }
      if (params.ordering) {
        params.ordering += ',-id'
      }
      console.log(params)
      let promise = fetchPayments(params)
      return promise.then(this.enhanceListData).then((data) => {
        this.loading = false
        this.payments = data
        return data
      })
    },
    refresh: _.debounce(function () {
      this.getPayments()
    }, 400),
    deletePayment (item) {
      this.$root.$confirm('Usuń płatnośc', 'Czy na pewno usunąć płatność?', {confirmText: 'Usuń', color: 'error'}).then((willDelete) => {
        if (willDelete) {
          let promise = deletePayment(item)
          return promise.then(() => {
            this.refresh()
            iziToast.show({
              message: 'Płatność została usunięta',
              color: 'green'
            })
          }).catch(() => {
            iziToast.show({
              message: 'Nie udało się usunąć płatności. Została już opłacona.',
              color: 'red'
            })
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/payments/AdminPayments.vue